// Should stay in sync with appraiserAssignmentTypes.mjs
export const APPRAISER_ASSIGNMENT_ATM_TYPES = {
  ISACA_ATMS: 0,
  INTERNAL_ATMS: 1,
  ISACA_EXTRAS: 2,
  INTERNAL_EXTRAS: 3,
  FDA_EXTRAS: 4
};
